import express from 'express';
import { resolve } from 'path';
import { existsSync } from 'fs';
import { AutoRouter } from '../routing/autoRouter.js';
import { createSSRStream } from '../renderer/ssrRenderer.js';

interface StartConfig {
    appDir: string;
    port: number;
    host: string;
    distDir: string;
}

export async function startSSRServer(config: StartConfig) {
    const { appDir, port, host, distDir } = config;

    console.log('🚀 Iniciando servidor SSR rowiejs...');

    // Verificar que existe la carpeta app
    if (!existsSync(appDir)) {
        console.error(`❌ No se encontró la carpeta ${appDir}`);
        process.exit(1);
    }

    const app = express();

    // Servir archivos estáticos
    app.use(express.static(resolve(distDir, 'assets')));

    // Middleware para SSR
    app.get('*', async (req, res) => {
        try {
            // Escanear rutas
            const router = new AutoRouter(appDir);
            await router.scanRoutes();

            // Encontrar ruta actual
            const currentRoute = router.findRouteByPath(req.url);

            if (currentRoute) {
                // Cargar componente de la página
                const componentPath = resolve(currentRoute.component);
                const component = await import(componentPath);
                const PageComponent = component.default;

                // Extraer parámetros de la ruta
                const params = router.extractParamsFromPath(currentRoute, req.url);

                // Crear contexto SSR
                const context = {
                    route: currentRoute,
                    params,
                    searchParams: {}
                };

                // Renderizar con streaming
                const stream = await createSSRStream(PageComponent, context);

                res.setHeader('Content-Type', 'text/html');
                stream.pipe(res);
            } else {
                res.status(404).send('Página no encontrada');
            }
        } catch (error) {
            console.error('Error en SSR:', error);
            res.status(500).send('Error interno del servidor');
        }
    });

    // Iniciar servidor
    app.listen(port, host, () => {
        console.log(`✅ Servidor SSR ejecutándose en http://${host}:${port}`);
        console.log(`📁 Escaneando rutas en: ${appDir}`);
    });
}
